/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from "@angular/core";
import { AbstractResourceService, JsonApiListResourceMetadataBase, JsonApiResource } from "@irian-ro/abstract-resource";
import { HttpClient } from "@angular/common/http";
import {EnvironmentService} from "@irian-ro/util-environment";
import { Observable } from "rxjs";
import { OfferDtoModel, OfferTemplateMetadataModel, OfferVO } from "@well/domain";

@Injectable({
  providedIn: 'root'
})
export class OfferResourceService extends AbstractResourceService<any, any, any, any> {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('offerUrl'),
      undefined,
      undefined
    );
  }

  updateVehicle(offerDTO: OfferDtoModel)
    : Observable<JsonApiResource<OfferDtoModel, any>> {
    return this.httpClient?.patch(`${this.url}/update/vehicle`, offerDTO)
      .pipe(this.getDtoMapper());
  }

  getOfferTemplate(uuid: string)
    : Observable<JsonApiResource<OfferDtoModel, any>> {
    return this.httpClient?.get(`${this.url}/template/${uuid}`)
      .pipe(this.getDtoMapper());
  }

  getOfferFromOfferRequestTemplate(offerRequestUuid: string, query = '')
    : Observable<JsonApiResource<OfferDtoModel, OfferTemplateMetadataModel>> {
    return this.httpClient?.get(`${this.url}/offer-request/template/${offerRequestUuid}?${query}`)
      .pipe(this.getDtoMapper());
  }

  getOfferFromOfferTemplate(offerUuid: string)
    : Observable<JsonApiResource<OfferDtoModel, any>> {
    return this.httpClient?.get(`${this.url}/template/existing-offer/${offerUuid}`)
      .pipe(this.getDtoMapper());
  }

  getOfferFromMasterRoutingSolutionTemplate(masterRoutingSolutionUuid: string)
    : Observable<JsonApiResource<OfferDtoModel, any>> {
    return this.httpClient?.get(`${this.url}/master-routing-solution/template/${masterRoutingSolutionUuid}`)
      .pipe(this.getDtoMapper());
  }

  getOfferPreviewFromOffer(offerUuid: string)
    : Observable<OfferVO> {
    return this.httpClient?.get(`${this.url}/preview/${offerUuid}`)
      .pipe(this.getDtoMapper());
  }

  refuseOffer(offerUuid: string, refuseReason: string)
    : Observable<JsonApiResource<OfferVO, JsonApiListResourceMetadataBase>> {
    return <Observable<JsonApiResource<OfferVO, JsonApiListResourceMetadataBase>> >this.httpClient?.patch(`${this.url}/refuse/${offerUuid}/${refuseReason}`, null);
  }

  resendOfferEmail(uuid: string) {
    return this.httpClient?.post(`${this.url}/resend-email`, uuid);
  }
}
